import styled, { css } from 'styled-components';
import { Set, Heading, Text, Row, SetSpacing } from '@bechtel/gds';

export const FieldError = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.bechtel.red};
  `}
`;

export const BlockHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
  `}
`;

export const BlockInputStyled = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings[500]};
  `}
`;

export const BlockTypeRowStyled = styled(Row)`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings[500]};
    padding-top: ${theme.spacings[500]};
    &:not(:last-child) {
      border-bottom: solid 1px ${theme.colors.grey[300]};
    }
  `}
`;

export const BlockSetStyled = styled(Set).attrs({
  spacing: SetSpacing.LARGE,
})`
  ${({ theme }) => css`
    padding-top: ${theme.spacings[500]};
    &:not(:last-child) {
      border-bottom: solid 1px ${theme.colors.grey[300]};
    }
  `}
`;
